<template>
  <v-app>
    <div>
      <Navbar :voltar="true" app />
      <Sidebar />

      <v-main>
        <v-container class="container" fluid>
          <v-card class="mx-auto content" max-width="1000" elevation="0">
            <v-toolbar color="#343F53">
              <v-card-title
                class="headline font-weight-bold d-flex align-center justify-space-between px-4 w-100"
              >
                <spam style="color: white"
                  >Cadastro de Moderador - Despedida {{ idDespedida }}</spam
                >
              </v-card-title>
            </v-toolbar>

            <v-card-text>
              <v-form v-model="valid" class="pa-4">
                <v-row dense>
                  <template v-if="!codigoEnviado">
                    <v-col cols="12" class="d-flex justify-center">
                      <v-card flat width="600" class="pa-0 ma-0">
                        <v-row no-gutters>
                          <p class="text-center mb-2 font-weight-medium">
                            Preencha o telefone para dar inicio ao cadastro de
                            Moderador!
                          </p>
                          <v-col cols="8">
                            <v-text-field
                              :readonly="
                                codigoEnviado ||
                                loadingEnvioCod ||
                                loadingValidCod
                              "
                              v-model="moderador.phone"
                              :rules="phoneRules"
                              label="Telefone do Moderador"
                              hide-details
                              v-mask="'(##) #####-####'"
                              required
                              class="custom-text-field"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="4" class="d-flex align-center pl-2">
                            <!-- Botão Iniciar Cadastro -->
                            <v-btn
                              color="#343F53"
                              :disabled="loadingEnvioCod"
                              @click="enviarToken"
                              size="small"
                              variant="outlined"
                              class="ml-2"
                              :loading="loadingEnvioCod"
                            >
                              Iniciar Cadastro
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </template>

                  <!-- Código de Verificação -->
                  <v-col cols="12" md="12" v-if="isVisibleToken && !isVisible">
                    <div class="d-flex align-center justify-center">
                      <span
                        >Insira o código de 5 dígitos que enviamos para o
                        telefone {{ moderador.phone }}</span
                      >
                    </div>
                    <v-otp-input
                      v-model="moderador.token"
                      :disabled="loadingValidCod"
                      :length="5"
                      class="custom-otp-input"
                      hide-details
                      required
                    ></v-otp-input>
                  </v-col>

                  <v-col
                    cols="12"
                    class="d-flex justify-center"
                    v-if="!isVisible"
                  >
                    <template v-if="codigoEnviado">
                      <v-btn
                        @click="reiniciarCadastro()"
                        color="#343F53"
                        size="small"
                        variant="outlined"
                        class="mr-2"
                        :disabled="loadingValidCod"
                      >
                        Alterar telefone
                      </v-btn>
                      <!-- Botão Reenviar Código -->
                      <v-btn
                        color="#343F53"
                        :disabled="
                          isWaiting || loadingEnvioCod || loadingValidCod
                        "
                        @click="enviarToken"
                        size="small"
                        variant="outlined"
                        class="mr-2"
                        :loading="loadingEnvioCod"
                      >
                        {{
                          isWaiting
                            ? `Reenviar (${tempoRestante}s)`
                            : "Reenviar Código"
                        }}
                      </v-btn>
                    </template>
                    <v-btn
                      v-if="isVisibleToken"
                      color="#343F53"
                      @click="verificarToken()"
                      size="small"
                      variant="flat"
                      :disabled="loadingValidCod"
                      :loading="loadingValidCod"
                    >
                      Validar Código
                    </v-btn>
                  </v-col>

                  <template v-if="isVisible">
                    <v-col cols="12">
                      <v-text-field
                        v-model="moderador.nome"
                        :rules="nameRules"
                        label="Nome"
                        hide-details
                        required
                        class="custom-text-field"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        :disabled="moderadorExistente"
                        v-model="moderador.email"
                        :rules="emailRules"
                        label="E-mail do Moderador"
                        hide-details
                        required
                        class="custom-text-field"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        :disabled="moderadorExistente"
                        v-model="moderador.password"
                        :type="showPassword ? 'text' : 'password'"
                        :rules="passwordRules"
                        label="Senha do Moderador"
                        hide-details
                        required
                        class="custom-text-field"
                      >
                        <template v-slot:append-inner>
                          <v-icon
                            @click="showPassword = !showPassword"
                            class="cursor-pointer"
                          >
                            {{ showPassword ? "mdi-eye-off" : "mdi-eye" }}
                          </v-icon>
                        </template>
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-select
                        v-model="moderador.moderador_cliente"
                        label="Moderador é cliente?"
                        :items="['Sim, cliente do Grupo', 'Ainda não']"
                        required
                      ></v-select>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-select
                        v-model="moderador.parentesco_falecido"
                        label="Parentesco com falecido?"
                        :items="['Não informado', 'Sim', 'Não']"
                        clearable
                        required
                      ></v-select>
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                      v-if="moderador.parentesco_falecido === 'Sim'"
                    >
                      <v-autocomplete
                        v-model="moderador.tipo_parentesco"
                        label="Qual o parentesco?"
                        :items="[
                          'Pai',
                          'Mãe',
                          'Filho(a)',
                          'Irmão(ã)',
                          'Avô(ó)',
                          'Tio(a)',
                          'Sobrinho(a)',
                          'Primo(a)',
                          'Cônjuge',
                          'Amigo(a)',
                          'Outros',
                        ]"
                        clearable
                        required
                      ></v-autocomplete>
                    </v-col>
                  </template>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                @click="cadastrarModerador()"
                :disabled="!valid || !codigoValidado"
                :loading="loadingEnvioCod"
              >
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-container>
      </v-main>
    </div>
    <Footer />
  </v-app>
</template>

<script>
import Navbar from "@/components/restrito/Navbar.vue";
import { http } from "@/services/config";
import authHeader from "@/services/auth-header";
import Sidebar from "./Sidebar.vue";
import Footer from "./Footer.vue";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  nome: "UserProfile",
  components: {
    Sidebar,
    Navbar,
    Footer,
  },
  computed: {
    idDespedida() {
      return this.$route.params.idDespedida;
    },
  },
  data() {
    return {
      phoneRules: [(v) => !!v || "Telefone é obrigatório"],
      moderador: {
        nome: "",
        phone: "",
        email: "",
        password: "",
        moderador_cliente: "",
        parentesco_falecido: "",
        token: "",
        tipo_parentesco: "",
      },
      moderadorGerado: {},
      loadingEnvioCod: false,
      loadingValidCod: false,
      validacaoModerador: false,
      moderadorExistente: false,
      isVisibleToken: false,
      codigoEnviado: false,
      codigoValidado: false,
      isVisible: false,
      isWaiting: false,
      tempoRestante: 0,
      valid: false,
      despedida: {},
    };
  },
  mounted() {
    this.despedidas();
  },
  methods: {
    async updateDespedida() {
      this.despedida.pessoa_moderador = this.moderadorGerado;

      try {
        const response = await http.post("cliente/update-despedida",
          this.despedida,
          {
            headers: authHeader(),
          }
        );
        if (!response) {
          console.log(response);
        }
        toast.success("Moderador atualizado com sucesso!");
        this.$router.push("/admin/despedidas");

      } catch (error) {
        console.error("Erro ao cadastrar despedida:", error);
        throw error;
      }
    },
    despedidas() {
      http
        .get(`cliente/despedida/${this.idDespedida}`, {
          headers: authHeader(),
        })
        .then((response) => {
          this.despedida = response.data;
        })
        .catch((error) => {
          console.error("Erro ao consultar:", error);
        });
    },
    async cadastrarModerador() {
      if(this.moderadorExistente) {
        this.updateDespedida();
        return;
      }
      try {
        const emailValido = await this.verificarEmail(this.moderador.email);
        if (emailValido) {
          toast.error(
            "E-mail já está registrado. Por favor informe outro para cadastro!"
          );
          return;
        }
      } catch (error) {
        console.error("Erro ao verificar o e-mail:", error);
        toast.error("Erro ao verificar o e-mail.");
        return;
      }
      try {
        const response = await http.post(
          "cliente/nova-pessoa-moderador",
          {
            username: this.moderador.email,
            password: this.moderador.password,
            pessoa: {
              nome: this.moderador.nome,
              telefone: this.moderador.phone,
              moderador_cliente: this.moderador.moderador_cliente,
              parentesco_falecido: this.moderador.parentesco_falecido,
              tipo_parentesco: this.moderador.tipo_parentesco,
            },
          },
          {
            headers: authHeader(),
          }
        );
        console.log(response);
        this.moderadorGerado = response.data;

        this.updateDespedida();
        toast.success("Moderador cadastrado com sucesso!");
        this.$router.push("/admin/despedidas");
      } catch (error) {
        console.error("Erro ao cadastrar moderador:", error);
        throw error;
      }
    },
    pararTemporizador() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
      this.isWaiting = false;
      this.tempoRestante = 0;
    },
    async verificarToken() {
      if (!this.moderador.token) {
        toast.error("Informe o código de verificação!");
        return;
      }
      this.loadingValidCod = true;
      const phoneTratado = this.moderador.phone.replace(/\D/g, "");

      // Parar o temporizador ao validar o código
      this.pararTemporizador();

      try {
        const response = await http.post(
          `validacao/verificar`, // Endpoint
          null,
          {
            params: {
              telefone: phoneTratado,
              token: this.moderador.token,
            },
            headers: authHeader(),
          }
        );

        if (response.status === 200 && response.data.mensagem === "Sucesso") {
          this.codigoValidado = true;
          this.isVisible = true; // Isso mostra o formulário de dados do moderador
          this.validacaoModerador = true;
          this.pararTemporizador();
        } else {
          toast.error("Código incorreto!");
        }
        if (response.data.existente) {
          this.moderadorGerado = response.data.pessoa;
          this.moderador = response.data.pessoa;
          this.moderadorExistente = true;
        }
      } catch (error) {
        console.error("Erro ao validar o token:", error);
        toast.error("Erro ao validar o token!");
      }
      this.loadingValidCod = false;
    },
    async enviarToken() {
      try {
        const phoneTratado = this.moderador.phone.replace(/\D/g, "");
        this.loadingEnvioCod = true;
        if (!phoneTratado || phoneTratado.length !== 11) {
          toast.error("Informe um número de telefone válido!");
          return;
        }

        const response = await http.post(`validacao/salvar`, null, {
          params: {
            telefone: phoneTratado,
          },
          headers: authHeader(),
        });
        console.log(response);
      } catch (error) {
        console.error("Erro ao enviar token:", error);
        throw error;
      }
      this.loadingEnvioCod = false;
      this.isVisibleToken = true;
      this.codigoEnviado = true;
      this.iniciarTemporizador();
    },
    iniciarTemporizador() {
      this.isWaiting = true;
      this.tempoRestante = 150;

      // Se já houver um temporizador rodando, limpa ele antes de iniciar um novo
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }

      this.intervalId = setInterval(() => {
        if (this.tempoRestante > 0) {
          this.tempoRestante--;
        } else {
          this.isWaiting = false;
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
      }, 1000);
    },
    async verificarEmail(email) {
      try {
        const response = await http.post(`validacao/verificar-email`, null, {
          params: {
            email: email,
          },
          headers: authHeader(),
        });
        console.log(response.data);
        return response.data;
      } catch (error) {
        console.error("Erro ao validar o token:", error);
        return false;
      }
    },
  },
};
</script>

<style scoped>
.v-main {
  background-color: #f5f5f5;
}
.container {
  min-height: 78vh !important;
}
</style>
